import { isEditorShortcutBlocked } from "./shortcut-event";

/** Pointer selection must leave the previous input, settle its blur commit, then capture an edit baseline. */
export function focusEditingSurface(
  surface: Pick<HTMLElement, "focus">,
  origin: EventTarget | null,
  settle: () => void,
): boolean {
  if (isEditorShortcutBlocked({ type: "keydown", target: origin }))
    return false;
  surface.focus({ preventScroll: true });
  settle();
  return true;
}
